const ADD_WEBHOOK = {
  ADD_PAGE_HEADER_TITLE: 'Webhook',
  ADD_PAGE_HEADER_DESCRIPTION:
    "A webhook allows you to send a notification to your app via Raychat automatically. You can receive and exploit users' messages and requests using webhooks.",

  ADD_PAGE_WEBSITE_TITLE: 'Choose your website',
  ADD_PAGE_WEBSITE_SELECT_TITLE: 'Website',

  ADD_PAGE_ADDRESS_INPUT_TITLE: 'Enter your webhook address',
  ADD_PAGE_ADDRESS_INPUT_PLACEHOLDER: 'https://example.com',
  ADD_PAGE_ADDRESS_INPUT_DESCRIPTION:
    'If necessary, enter your internet address as percent-encoded.',
  ADD_PAGE_TOKEN_TITLE: 'Dedicated token',
  ADD_PAGE_TOKEN_OPTIONAL_NOTE: 'Optional',
  ADD_PAGE_TOKEN_DESC:
    'This token is added in the header with the key X-Raychat-Token to the relevant requests and you can use it to validate the received data.',
  ADD_PAGE_TOKEN_INPUT_PLACEHOLDER: 'Enter token',
  ADD_PAGE_EVENTS_TITLE: 'events',
  ADD_PAGE_EVENTS_DESC:
    'In this section, you can choose what kind of data you want to receive.',
  ADD_PAGE_EVENTS_NEW_MSG_LABEL: 'New message',
  ADD_PAGE_EVENTS_NEW_CONV_LABEL: 'New conversation',

  ADD_PAGE_EDIT_BTN_LABEL: 'Edit',
  ADD_PAGE_ADD_BTN_LABEL: 'Add',

  ADD_PAGE_EMPTY_ADDRESS_ERROR: 'Please enter webhook address',
  ADD_PAGE_INVALID_ADDRESS: 'Webhook address is invalid',
  ADD_PAGE_ADDRESS_PROTOCOL_ERROR:
    'Only pages with HTTPS protocol are accepted',
  ADD_PAGE_EVENT_TYPE_NOT_SELECTED:
    'It is necessary to select at least one of the events',
};

export default ADD_WEBHOOK;
